module.exports = __webpack_public_path__ + "img/img_74.912c6e7a.png";